import styled from 'styled-components';

export const AboutBox = styled.div`
  background-color: #fff;
  padding: 24px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 32px;
  }
`;

export const Divider = styled.div`
  border-bottom: 1px solid;
  border-color: ${(props) => props.theme.colors['neutral-30']};
  padding-top: 32px;
  margin-bottom: 32px;
`;

export const AboutTab = styled.p`
  border-radius: 8px 8px 0 0;
  padding: 8px 16px;
  background: #fff;
  display: inline-block;
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 8px 32px;
    font-size: 18px;
  }
`;
